import styled from 'styled-components';

export const Text = styled.p`
  margin: 0;
  font-weight: 300;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.greys.sharedDarkGrey};
`;
